angular.module('impactx.purchaseorder').controller('PurchaseOrderListCtrl', ['selectedListItems',
    '$redirect',
    '$mdDialog',
    'dataGen',
    'ToastService',
    'TranslationService',
    'OpenGovernmentDataService',
    'CancellationService',
    '$scope',
    'DownloadService',
    'EformsHandoffService',
    PurchaseOrderListCtrl]);

function PurchaseOrderListCtrl(selectedListItems, $redirect, $mdDialog, dataGen, ToastService, TranslationService, OpenGovernmentDataService, CancellationService, $scope, DownloadService, EformsHandoffService) {
    var ctrl = this;
    this.checkMultiple = function (event, trns) {
        var multiOk = true;
        var selected = selectedListItems.getSelectedItems();
        if (selected.length > 1) {
            for (var i = 0; i < selected.length; i++) {
                if (!selected[i].multiplePOHForDNHAllowed || !selected[i].multiplePOHForDNHAllowed.value) {
                    multiOk = false;
                    break;
                }
            }
        }
        if (multiOk) {
            $redirect.redirectTo(null, "/deliverynote");
        }
        else {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .textContent(trns.multiplePOHError)
                    .ariaLabel('Alert Dialog')
                    .ok('Ok')
            );
        }
    };

    this.getDetailsLink = function () {
        return "purchaseorderdetail/" + selectedListItems.getFirstSelectedId();
    };

    this.getOrderConfirmationLink = function () {
        return "orderconfirmationbuyer/" + selectedListItems.getFirstSelectedId();
    };

    this.getDeliveryAdviceLink = function () {
        return "deliveryadvicebuyer/" + selectedListItems.getFirstSelectedId();
    };

    this.getDeliveryComplaintLink = function () {
        return "deliverycomplaint/0/0/" + selectedListItems.getFirstSelectedId();
    };

    this.canComplain = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canComplain;
    };

    this.hasCOMFailureStatus = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().hasCOMFailure;
    };

    this.sendPOHAgain = function () {
        dataGen.postAsForm({}, {pohId: selectedListItems.getFirstSelectedItem().id}, "/purchaseorder/sendagain").then(function (result) {
            if (result.data && result.data.status) {
                selectedListItems.getFirstSelectedItem().status = result.data.status;
            }
        });
    };

    this.markPOHAsSent = function () {
        dataGen.postAsForm({}, {pohId: selectedListItems.getFirstSelectedItem().id}, "/purchaseorder/markassent").then(function () {
            if (result.data && result.data.status) {
                selectedListItems.getFirstSelectedItem().status = result.data.status;
            }
        });
    };

    this.cancelItems = function (event) {
        var selected = [];
        angular.forEach(selectedListItems.getSelectedIds(), function (id) {
            selected.push({pohId: id});
        });

        CancellationService.cancelItems(event, selected);
    };

    this.cancelAll = function (event) {
        var selected = [];

        angular.forEach(selectedListItems.getSelectedIds(), function (id) {
            selected.push({pohId: id});
        });

        CancellationService.cancelAll(event, selected);
    };

    this.reportOpenGovernmentData = function (event) {
        var pohId = selectedListItems.getFirstSelectedItem().pohId;
        dataGen.getData({}, {pohId: pohId}, "/opengovernmentdata/purchaseorder/check").then(function (rsp) {
            if(rsp && rsp.data)
            {
                if(!rsp.data.noInfo)
                {
                    $mdDialog.show({
                        controller: 'OpenGovernmentDataOverdueDialogCtrl',
                        controllerAs: 'ctrl',
                        locals: {
                            pohId: pohId
                        },
                        templateUrl: 'modules/opengovernmentdata/templates/opengovernmentoverdue.dialog.html',
                        parent: angular.element(document.body),
                        bindToController: true,
                        targetEvent: event,
                        data: rsp.data,
                        trns: rsp.trns
                    }).then(function () {
                        OpenGovernmentDataService.openEditDialogWithWarnings(pohId)
                    });
                }
                else
                {
                    OpenGovernmentDataService.openEditDialogWithWarnings(pohId)
                }
            }
        })
    };

    this.exportOpenGovernmentData = function (event) {
        dataGen.postAsForm({}, {pohId: selectedListItems.getFirstSelectedItem().id}, "/opengovernmentdata/purchaseorder/export").then(function (result) {
            if (result.data && result.data.status) {
                selectedListItems.getFirstSelectedItem().status = result.data.status;
            }
        });
    };

    this.showCancelButton = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canCancel.value;
    };

    this.showOrderConfirmationButton = function () {
        return selectedListItems.isSingleSelection() && !selectedListItems.getFirstSelectedItem().isCancel.value;
    };

    this.showDeliveryAdviceButton = function () {
        return selectedListItems.isSingleSelection() && !selectedListItems.getFirstSelectedItem().isCancel.value;
    };

    this.showCreateDelNoteButton = function () {
        return selectedListItems.isMultiSelection() && !selectedListItems.getFirstSelectedItem().isCancel.value;
    };

    this.canReportOGD = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canReportOGD.value && !selectedListItems.getFirstSelectedItem().isCancel.value;
    };

    /*
     * The backend flag already folds active eForms, contract type and permission into one boolean, so
     * no business rule is repeated here. Cancellation rows are excluded exactly like for reportOGD --
     * a cancellation order has no contract award of its own to announce.
     * Mirrors canAnnounceEForms() of the Angular PurchaseOrderListComponent.
     */
    this.canAnnounceEForms = function () {
        var item = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && item
            && item.canAnnounceEForms && item.canAnnounceEForms.value === true
            && !(item.isCancel && item.isCancel.value);
    };

    /*
     * Jumps off to the eForms handoff page for the selected order. A blocked popup is reported by the
     * service instead of being swallowed.
     */
    this.announceEForms = function () {
        var item = selectedListItems.getFirstSelectedItem();
        if (!item) {
            return;
        }

        EformsHandoffService.openHandoff(item.pohId);
    };

    this.canExportOGD = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canExportOGD.value && !selectedListItems.getFirstSelectedItem().isCancel.value;
    };

    this.canCreateSPOReportAsExcel = function () {
        return selectedListItems.isNoSelection() && $scope.$$childHead.data.actions.canCreateSPOReportAsExcel.allowed;
    };

    this.createSPOReportAsExcel = function () {
        DownloadService.openDownloadPost('/subsequentpurchaseorderdata/export/report', {paramName: "config", paramValue: $scope.$$childHead.metaData.params.listConfig});
    };

    var buttonDefinition = [
        {
            label: "createSPOReportAsExcel",
            action: ctrl.createSPOReportAsExcel,
            condition: ctrl.canCreateSPOReportAsExcel,
        },
        {
            label: "details",
            linkFunction: ctrl.getDetailsLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'PurchaseOrderView'
        },
        {
            label: "orderConfirmation",
            linkFunction: ctrl.getOrderConfirmationLink,
            type: 'link',
            condition: ctrl.showOrderConfirmationButton,
            process: 'EditOrderConfirmation'
        },
        {
            label: "deliveryAdvice",
            linkFunction: ctrl.getDeliveryAdviceLink,
            type: 'link',
            condition: ctrl.showDeliveryAdviceButton,
            process: 'EditDeliveryAdvice'
        },
        {
            label: "newComplaint",
            linkFunction: ctrl.getDeliveryComplaintLink,
            type: 'link',
            condition: ctrl.canComplain,
            process: 'ViewDeliveryComplaint'
        },
        {
            label: "createDelNote",
            action: ctrl.checkMultiple,
            condition: ctrl.showCreateDelNoteButton,
            process: 'EditDeliveryNote'
        },
        {label: "cancel", action: ctrl.cancelItems, condition: ctrl.showCancelButton, process: 'Cancellation'},
        {label: "cancelAll", action: ctrl.cancelAll, condition: ctrl.showCancelButton, process: 'Cancellation'},
        {
            label: "sendAgain",
            action: ctrl.sendPOHAgain,
            condition: ctrl.hasCOMFailureStatus,
            process: 'FailedPurchaseOrderHandling'
        },
        {
            label: "markAsShipped",
            action: ctrl.markPOHAsSent,
            condition: ctrl.hasCOMFailureStatus,
            process: 'FailedPurchaseOrderHandling'
        },
        {
            label: "reportOGD",
            action: ctrl.reportOpenGovernmentData,
            condition: ctrl.canReportOGD,
            process: 'ReportOGDSubsequently'
        },
        {
            // no process: the buyer of the order may announce it without holding ReportOGDSubsequently
            label: "announceEForms",
            action: ctrl.announceEForms,
            condition: ctrl.canAnnounceEForms
        },
        {
            label: "exportOGD",
            action: ctrl.exportOpenGovernmentData,
            condition: ctrl.canExportOGD,
            process: 'ExportOGD'
        },
    ];

    this.meta = {
        rowTemplate: 'modules/purchaseorder/templates/purchaseorderlist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/purchaseorder/list',
        ctrl: this,
        id: "purchaseorderlist",
        totalList: {url: "purchaseorderlist", disabled: true, translationKey: "orderList"},
        singleList: {url: "purchaseorderitemlist", disabled: false, translationKey: "orderPositionList"},
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}
